
import { NavHeader } from "@/components/layout/nav-header";
import { SMSPreferencesTable } from "@/components/admin/sms-preferences-table";

export default function AdminSMS() {
  return (
    <div className="min-h-screen bg-background">
      <NavHeader />
      <main className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6">SMS Notification Preferences</h1>
        <SMSPreferencesTable />
      </main>
    </div>
  );
}
